// extracted by mini-css-extract-plugin
export var deleteModal = "_ej-0";